/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:39:17
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-05-28 15:50:24
 */
import configData from "../config/config";
import { RouteConfig } from "vue-router";
import mumeListData from "./menu";
import { objAny } from "../common/common-interface";

import Home from "../views/home/home.vue";
import ShareSettlement from "../views/revenue-settlement/share-settlement/share-settlement.vue";
import ShareSettlementDetail from "../views/oper-manage/charge-order-list/components/charge-order-detail.vue";

// /revenue-settlement/share-detail/charge-order-detail
import WithdrawForm from "../views/revenue-settlement/withdraw-form/withdraw-form.vue";
import WithdrawFormAdd from "../views/revenue-settlement/withdraw-form/children/withdraw-form-add.vue";
import WithdrawFormPreview from "../views/revenue-settlement/withdraw-form/children/cash-template.vue";
import WithdrawFormEdit from "../views/revenue-settlement/withdraw-form/children/withdraw-form-add.vue";

import operationData from "../views/oper-manage/operation-data/operation-data.vue";
import chargeOrderList from "../views/oper-manage/charge-order-list/charge-order-list.vue";
import cashTopUp from "../views/oper-manage/cash-top-up/cash-top-up.vue";
import chargeOrderDetail from "../views/oper-manage/charge-order-list/components/charge-order-detail.vue";
import abnormalOrder from "../views/oper-manage/charge-order-list/components/abnormal-order.vue";

import pileInfo from "../views/pile-manage/pile-info/pile-info.vue";
import pileInfoDetail from "../views/pile-manage/pile-info/children/site-details/site-details.vue";

import pileList from "../views/pile-manage/pile-list/pile-list.vue";
import pileListDetail from "../views/pile-manage/pile-list/children/edit-pile.vue";

//
import siteMonitor from "../views/operation-analysis/site-monitor/site-monitor.vue";
// import alarmList from "../views/operation-analysis/alarm-list/alarm-list.vue";
// import alarmDetail from "../views/operation-analysis/alarm-list/children/pi-alarm-detail.vue";
import alarmEvent from "../views/operation-analysis/alarm-event/alarm-event.vue";

//
import NonRealNameCardManagement from "../views/member-management/non-real-name-card-management/non-real-name-card-management.vue";
import nonRealAddCard from "../views/member-management/non-real-name-card-management/children/non-real-add-card.vue";
import nonRealRecharge from "../views/member-management/non-real-name-card-management/children/non-real-recharge.vue";
import nonRealDelCard from "../views/member-management/non-real-name-card-management/children/non-real-del-card.vue";
import nonRealEditCard from "../views/member-management/non-real-name-card-management/children/non-real-edit-card.vue";
import nonRealNameCardDetail from "../views/member-management/non-real-name-card-management/children/non-real-detail.vue";
import nonRealHistory from "../views/member-management/non-real-name-card-management/children/non-real-history.vue";
import nonFundHistory from "../views/member-management/non-real-name-card-management/children/non-fund-history.vue";
import nonRealRefund from "../views/member-management/non-real-name-card-management/children/non-real-refund.vue";

import MerchantManagement from "../views/merchant-management/merchant-management/merchant-management.vue";
//
const allRouter: Array<RouteConfig> = [
  {
    path: "/home",
    name: "主页",
    component: Home
  },
  // {
  //   path: "/test",
  //   name: "主页2",
  //   component: Test
  // },
  // {
  //   path: "/revenue-settlement",
  //   name: "收入结算",
  //   component: RevenueSettlement
  // },
  {
    path: "/revenue-settlement/share-settlement",
    name: "分成结算",
    component: ShareSettlement
  },
  {
    path: "/revenue-settlement/share-settlement/share-settlement-detail",
    name: "分成结算订单详情",
    component: ShareSettlementDetail
  },
  {
    path: "/revenue-settlement/withdraw-form",
    name: "提现单",
    component: WithdrawForm
  },
  {
    path: "/revenue-settlement/withdraw-form/withdraw-form-add",
    name: "新增提现单",
    component: WithdrawFormAdd
  },
  {
    path: "/revenue-settlement/withdraw-form/cash-template",
    name: "预览提现单",
    component: WithdrawFormPreview
  },
  {
    path: "/revenue-settlement/withdraw-form/withdraw-form-edit",
    name: "重新提交提现单",
    component: WithdrawFormEdit
  },
  {
    path: "/oper-manage/operation-data",
    name: "运营数据",
    component: operationData
  },
  {
    path: "/oper-manage/charge-order-list",
    name: "充电订单",
    component: chargeOrderList
  },
  {
    path: "/oper-manage/cash-top-up",
    name: "现金充值",
    component: cashTopUp
  },
  {
    path: "/oper-manage/charge-order-list/charge-order-detail",
    name: "充电订单详情",
    component: chargeOrderDetail
  },
  // /pile-manage/pile-info/edit-ele-pile
  {
    path: "/oper-manage/charge-order-list/abnormal-order",
    name: "异常订单",
    component: abnormalOrder
  },
  {
    path: "/pile-manage/pile-info",
    name: "站点信息",
    component: pileInfo
  },
  {
    path: "/pile-manage/pile-info/detail",
    name: "站点详情",
    component: pileInfoDetail
  },
  {
    path: "/pile-manage/pile-list",
    name: "充电桩信息",
    component: pileList
  },
  {
    path: "/pile-manage/pile-list/pile-detail",
    name: "充电桩详情",
    component: pileListDetail
  },
  {
    path: "/operation-analysis/site-monitor",
    name: "站点监控",
    component: siteMonitor
  },
  // {
  //   path: "/operation-analysis/alarm-list",
  //   name: "告警管理",
  //   component: alarmList
  // },
  // {
  //   path: "/operation-analysis/alarm-list/detail",
  //   name: "告警管理详情",
  //   component: alarmDetail
  // },
  {
    path: "/operation-analysis/alarm-event",
    name: "事件告警",
    component: alarmEvent
  },
  //
  {
    path: "/member-management/non-real-name-card-management",
    name: "非实名卡管理",
    component: NonRealNameCardManagement
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-add-card",
    name: "开卡",
    component: nonRealAddCard
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-recharge",
    name: "充值",
    component: nonRealRecharge
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-edit-card",
    name: "编辑",
    component: nonRealEditCard
  },
  {
    path:
      "/member-management/non-real-name-card-management/non-real-name-card-detail",
    name: "非实名卡详情",
    component: nonRealNameCardDetail
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-del-card",
    name: "注销",
    component: nonRealDelCard
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-history",
    name: "操作记录",
    component: nonRealHistory
  },
  {
    path: "/member-management/non-real-name-card-management/non-fund-history",
    name: "资金记录",
    component: nonFundHistory
  },
  {
    path: "/member-management/non-real-name-card-management/non-real-refund",
    name: "退款",
    component: nonRealRefund
  },
  {
    path: "/merchant-management/merchant-management",
    name: "商户信息",
    component: MerchantManagement
  },
  {
    path: "/oper-manage/off-card-order",
    name: "离线卡订单",
    component: () =>
      import("@/views/oper-manage/off-card-order-list/off-card-order-list.vue")
  },
  {
    path: "/oper-manage/off-card-order/charge-order-detail",
    name: "离线卡订单详情",
    component: () =>
      import(
        "@/views/oper-manage/off-card-order-list/children/off-order-detail.vue"
      ),
    meta: {
      nameKey: "offCardOrderDetails"
    }
  }
];

// 把权限单独拿出来拼到路由里面去
const getPower = (list: object[]): objAny => {
  const prwerObj: objAny = {};
  const config: objAny = configData.powerObj;
  list.map((item: objAny) => {
    if (config[item.privilegeCode]) {
      prwerObj[config[item.privilegeCode]] = item.checked;
    }
  });
  return prwerObj;
};
const routerObj: objAny = {};

const recursionRouter = (routerList: object[], itemData?: objAny): object[] => {
  const userRouter: object[] =
    routerList.length == 0 ? mumeListData : routerList;
  const realRoutes: object[] = [];
  userRouter.forEach((v: objAny) => {
    if (v.children && v.children.length > 0) {
      const list: object[] = recursionRouter(v.children, v);
      list.forEach((li: objAny) => {
        realRoutes.push(li);
      });
    } else {
      allRouter.forEach((item: objAny) => {
        const ischildren = v.children && v.children.length > 0;
        if (
          (item.path != "" && item.path === v.url) ||
          (item.path.indexOf(v.url) != -1 &&
            item.path.length > v.url.length &&
            !ischildren)
        ) {
          // console.log("??");
          // 1 条件是路径相同   2 条件是当前路径是某个的子级(子级路由的定义是在父级路由后面添加，所有一定比父级长)
          const data: objAny = JSON.parse(JSON.stringify(v));
          let privilegeVoObj: objAny = {};
          if (data.privilegeVoList && data.privilegeVoList.length > 0) {
            privilegeVoObj = getPower(data.privilegeVoList);
          }

          // routerObj 记录已经添加过的路由， item.path.indexOf(v.url) != -1 添加子路由的时候有可能会添加多次
          if (privilegeVoObj.query && !routerObj[item.path]) {
            if (item.meta) {
              item.meta.menuData = data;
              item.meta.privilegeVoObj = privilegeVoObj;
            } else {
              item.meta = {
                privilegeVoObj: privilegeVoObj,
                menuData: data
              };
            }
            if (itemData) {
              item.meta.parentName = itemData.moduleName;
            }
            if (item.path === v.url) {
              item.name = data.moduleName;
              item.meta.mainPage = true;
            }
            realRoutes.push(item);
            routerObj[item.path] = item.name;
          }

          // realRoutes.push(item);
        }
      });
    }
  });
  return realRoutes;
};

export default recursionRouter;
